import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one transition, its fields and executors
 * @primary Transition form
 * @persona danilo-tech
 */
export const Route = createFileRoute(
  "/app/admin/fsm-workflows/transitions/$id",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
